"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconTeam = function IconTeam(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconTeam', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    d: "M8.667 8.3C10.507 8.3 12 9.755 12 11.55v1.3c0 .359-.298.65-.667.65a.658.658 0 0 1-.666-.65v-1.3c0-1.077-.896-1.95-2-1.95H3.333c-1.104 0-2 .873-2 1.95v1.3c0 .359-.298.65-.666.65A.658.658 0 0 1 0 12.85v-1.3C0 9.755 1.492 8.3 3.333 8.3zm4.02.572a.668.668 0 0 1 .813-.467c1.47.37 2.499 1.663 2.5 3.145v1.3c0 .359-.298.65-.667.65a.658.658 0 0 1-.666-.65v-1.3c-.001-.888-.618-1.664-1.5-1.886a.649.649 0 0 1-.48-.792zM6 .5c1.84 0 3.333 1.455 3.333 3.25S7.841 7 6 7C4.16 7 2.667 5.545 2.667 3.75S4.159.5 6 .5zm4.02.573a.668.668 0 0 1 .812-.468c1.475.368 2.507 1.664 2.507 3.148 0 1.485-1.032 2.78-2.507 3.149a.668.668 0 0 1-.811-.469.649.649 0 0 1 .48-.79c.885-.222 1.504-1 1.504-1.89 0-.89-.619-1.668-1.504-1.889a.649.649 0 0 1-.48-.79zM6 1.8c-1.105 0-2 .873-2 1.95S4.895 5.7 6 5.7s2-.873 2-1.95S7.105 1.8 6 1.8z"
  }));
};

var _default = IconTeam;
exports.default = _default;